(() => {
  const dialog = document.querySelector('[data-account-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let trigger;
  const mode = (value) => {
    dialog.querySelectorAll('[data-account-panel]').forEach(panel => { panel.hidden = panel.dataset.accountPanel !== value; });
    dialog.querySelectorAll('[data-account-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.accountMode === value)));
    dialog.querySelector('#YndAccountTitle').textContent = value === 'login' ? dialog.dataset.loginTitle : dialog.dataset.registerTitle;
  };
  const open = (value = 'register') => {
    trigger = document.activeElement;
    const disclosure = trigger?.closest('.ynd-header details');
    if (disclosure) trigger = disclosure.querySelector('summary');
    mode(value);
    const returnPath = location.pathname.startsWith('//') ? '/' : location.pathname + location.search;
    dialog.querySelectorAll('input[name="return_to"]').forEach(input => { input.value = returnPath; });
    document.querySelectorAll('.ynd-header details[open]').forEach(detail => { detail.open = false; });
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('ynd-account-is-open');
    document.dispatchEvent(new Event('ynd:overlay'));
    dialog.querySelector('#YndAccountTitle').focus();
  };
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-account-close]')) dialog.close();
    const switcher = event.target.closest('[data-account-mode]');
    if (switcher) mode(switcher.dataset.accountMode);
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('ynd-account-is-open');
    document.dispatchEvent(new Event('ynd:overlay'));
    if (trigger?.isConnected) trigger.focus();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || dialog.contains(form)) return;
    const path = new URL(form.action, location.origin).pathname;
    const product = /\/cart\/add(?:\.js)?\/?$/.test(path);
    const checkout = /\/cart\/?$/.test(path) && event.submitter?.name === 'checkout';
    if (!product && !checkout) return;
    const buyButton = form.querySelector('[data-add-to-bag]');
    if (product && buyButton?.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || dialog.contains(link)) return;
    const url = new URL(link.href, location.origin);
    const checkout = url.origin === location.origin && /\/checkouts?(?:\/|$)/.test(url.pathname);
    if (!link.hasAttribute('data-account-open') && !checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(link.dataset.accountOpen || 'register');
  }, true);
})();
